module.exports = __webpack_public_path__ + "tests.html";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=[name].[ext]!./src/tests.html
 ** module id = 120
 ** module chunks = 1
 **/